// Shared persona/system user type constants
export const SYSTEM_USER_TYPES = {
  FOUNDER: "FOUNDER",
  INVESTOR: "INVESTOR",
  DFI_GOVT: "DFI/GOVT",
  ACCELERATOR: "ACCELERATOR",
  ACADEMIA: "ACADEMIA",
  GENERIC: "GENERIC",
  DEFAULT: "DEFAULT",
} as const;

export type UserType =
  (typeof SYSTEM_USER_TYPES)[keyof typeof SYSTEM_USER_TYPES];
